import React from 'react';

/**
 * Schedule — timeline list of events.
 *
 * Props:
 *   items     — [{ time, event|name, desc|subtitle|description }]
 *   classes   — { root, row, time, info, name, desc, rowBorder } — host styling
 */
export default function Schedule({ items = [], classes = {} }) {
  if (!items?.length) return null;
  const cls = {
    root:      classes.root      || 'sched',
    row:       classes.row       || 'sched-row',
    rowBorder: classes.rowBorder || 'sched-row--border',
    time:      classes.time      || 'sched-time',
    info:      classes.info      || 'sched-info',
    name:      classes.name      || 'sched-name',
    desc:      classes.desc      || 'sched-desc',
  };
  return (
    <div className={cls.root}>
      {items.map((item, i) => (
        <div key={i} className={`${cls.row}${i > 0 ? ' ' + cls.rowBorder : ''}`}>
          <span className={cls.time}>{item.time}</span>
          <div className={cls.info}>
            <span className={cls.name}>{item.name || item.event}</span>
            {(item.desc || item.subtitle || item.description) && (
              <span className={cls.desc}>{item.desc || item.subtitle || item.description}</span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
